import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { AS_TIMEZONE_MAPPING, AS_TIMEZONES } from '@/constants/time-zones';
import * as Sentry from '@sentry/react';
dayjs.extend(duration);

export const formatDate = (date) => {
  if (!date) return;
  return dayjs(date).format('ddd D MMM YYYY [at] H[:]mm A');
};

export const formatCreatedDate = (date) => {
  if (!date) return;
  return dayjs(date).format('DD[/]M[/]YYYY');
};

export const minutesToDay = (minutes) => {
  const days = dayjs.duration({ minutes }).asDays();
  if (days >= 1) {
    return days + ' day' + (days > 1 ? 's' : '');
  } else {
    const hours = dayjs.duration({ minutes }).asHours();
    return hours === 1 ? '60 mins' : hours + ' Hrs';
  }
};

export const getTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return null;
  }
};

export const toHHMMFormat = (offsetMinutes) => {
  const min = offsetMinutes % 60;
  const hours = Math.floor(offsetMinutes / 60);

  return `${padding(hours)}:${padding(min)}`;
};

export const padding = (num) => {
  return num?.toString()?.padStart(2, '0');
};

export const getUTCOffset = () => {
  // dayjs().utcOffset() gives offset in min.
  // Ex: -240, +480 etc.
  // This converts offset in minutes to UTC offset.
  // Ex: -480 to -08:00.
  try {
    const offsetInMin = dayjs().utcOffset();
    if (typeof offsetInMin !== 'number') return null;

    const negativeInt = offsetInMin < 0;
    const formattedOffset = toHHMMFormat(Math.abs(offsetInMin));

    return negativeInt ? '-' + formattedOffset : '+' + formattedOffset;
  } catch {
    return null;
  }
};

export const checkUserTZMatch = (time_zone) => {
  return AS_TIMEZONES?.indexOf(time_zone) >= 0;
};

// This one is basic suggestion to match the first in the list that has the same offset as the current user.
// This is a temporary hack and doesn't take into account DST timezones.
// Worst case +- 1 hour difference incase any timezone has DST. We will prompt the user to update based on the list if they feel
// one set by us isn't correct.
export const findSuggestedTimezone = () => {
  const tz = getTimeZone();
  if (checkUserTZMatch(tz)) {
    return tz;
  }

  const offset = getUTCOffset();
  try {
    return AS_TIMEZONES?.find((key) => AS_TIMEZONE_MAPPING?.[key] === offset);
  } catch (e) {
    Sentry.captureException(
      `Can't find suggested timezone for offset:${offset}`
    );
    return null;
  }
};
